import constants from '../constants';

export enum JobNames {
    None = "",
    Main = "Main",

    OceanImport = "SEAI",
    OceanExport = "SEAE",
    OIMbl = "OIMB",     // 1
    OIHbl = "OIHB",
    OEMbl = "OEMB",
    OEHbl = "OEHB",
    OE_QUOTATION = "OE_QUOTATION",
    AirImport = "AIRI",
    AirExport = "AIRE",
    AIMbl = "AIMB",
    AIHbl = "AIHB",
    AEMbl = "AEMB",
    AEHbl = "AEHB",
    Company = "COMP",

    Broker = "BRKR",     // 10
    CodeGroup = "CGRP",
    Sales = "SALE",
    Charge = "BILL",

    BillingCode = "BCODE",          //<pt200322: FMS>
    BillingTemplate = "BTEMP",      //<pt200325: FMS>

    OceanPort = "SPRT",
    Container = "CNTR",
    MoveType = "MVTY",
    Vessel = "VSSL",
    BLType = "BLTY",
    User = "USER",   //UDetail,

    GLNo = "GLNO",         // 20
    AirLine = "ALIN",
    AirLineEx = "ALIE",
    OtherType = "OTYP",
    AirPort = "APRT",
    Country = "CTRY",
    State = "STAT",
    ScheduleB = "SCHB",
    Scac = "SCAC",
    //public const string Eic: "EXIC",      // Export information code
    ExportInfo = "EXIC",        //<pt200322: Change field name>

    ExportLic = "EXLC",        // 30 - Export license code
    Bank = "BANK",
    BankRecon = "BREC",
    InternetUser = "IUSR",
    LogFax = "LOGF",
    LogMail = "LOGM",
    LogPrint = "LOGP",
    LogFaxErr = "LGFE",
    LogCommunication = 'LOGC',
    BatchFax = "BATF",
    BatchEmail = "BATM",
    BatchMemo = "BMEM",     //<pt200725: T_BatchMainHD>
    //        UInfo,

    Commodity = "CMDT",  // 40
    Currency = "CURR",
    MemoTitle = "MEMT",
    ANTitle = "ANTT",
    OITeu = "OTEU",
    Memo = "MEMO",
    FileAttach = "FATT",
    SubGLCode = "SBGL",
    EndYearProc = "EYPR",

    Lines = "LINES",
    Salesperson = "CSMAN",

    //#region Accounting

    AcctDashboard = "ACCDB",    //<pt200320>
    Invoice = "INVO",      // 50
    //public const string InvoiceList: "INVOL",  //<pt200320: For Security Task>
    CrDb = "CRDB",
    //public const string CrDbList: "CRDBL",     //<pt200320: For Security Task>
    //public const string Payable: "BILL",       // Old "APAY"
    Bill = "BILL",          //<pt200320: Change field name>
    //public const string BillList: "BILLL",     //<pt200320: For Security Task>
    //public const string GInvoiceList: "GINVL",     //<pt200320>
    GInvo = "GINVE",       //<pt200320: Security Task 때문에 분리>
    //public const string GBillList: "GBILL",        //<pt200320>
    GBill = "GBILE",       //<pt200320>

    //<pt200320: Why?
    //public const string Aphd: "T_APHD",        // 추가 양재환
    //public const string Invohd: "T_INVOHD",        // 추가 양재환
    //public const string Crdbhd: "T_CRDBHD",        // 추가 양재환
    //pt200320>

    //public const string Deposit: "CPAY",       // Deposit Journal  -->  Customer Payment  // Chuck 2014-04-02
    CustPayment = "CPAY",   //<pt200320: Change field name>
    AgntPayment = "APAY",   //241211 mskim add
    DepositBag = "DEPO",    // Deposit Bag //Lin 2014-04-04
    //public const string Check: "BPAY",         // Check Journal    -->  Bill Payment    // Old : "CHEK"
    BillPayment = "BPAY",   //<pt200320: Change field name>
    CCPayment = "CCPAY",    //<pt200320>

    CheckDeposit = "CHDP",  // Check Deposit
    UndoDeposit = "UNDPS",  //<pt200320>
    CheckClear = "CHCR",    // Check Clear
    CCClear = "CCCLR",              //<pt200320>
    CancelCCClear = "CANCC",        //<pt200320>
    ChkClearWithExcel = "CCEXL",    //<pt200320>
    BankBalRec = "BNKB",     // Bank Recon

    SlipJournal = "JRNL",
    //public const string SlipList: "SLPL",
    //public const string AdjJournalEntry: "AJRNL",  //<pt200320: Use SlipJournal>
    SearchJournal = "SJRNL",    //<pt200320>

    Settle = "SETL",
    ComChg = "CCHG",
    Branch = "BRAN",
    MergePort = "MRGP",
    ChkMessenger = "CHMS",

    RptAgingAr = "RAGAR",      //<pt200320>
    RptAgingAp = "RAGAP",      //<pt200320>
    RptAgingArAgent = "RAARA", //<pt200320>
    RptAgingApAgent = "RAAPA", //<pt200330>
    RptAgingAgent = "RAAGT",   //<pt200320>
    RptAgingChkRcvable = "RACKR",  //<pt200320>
    RptAgingChkPayable = "RACKP",  //<pt200320>
    RptAgingRcvable = "RARCV",     //<pt200320>
    RptAgingPayable = "RAPAY",     //<pt200320>
    RptAgingCCPayable = "RACCP",   //<pt200320>

    RptDailyAcctSummary = "RDACS",  //<pt200320>
    RptAcctBalByEntity = "RACBE",      //<pt200320>
    RptAcctLedger = "RACLG",           //<pt200320>
    RptAcctLedgerByEntity = "RACLE",   //<pt200320>
    RptGeneralLedger = "RGLDG",        //<pt200320>
    RptIncomeStatement = "RICST",      //<pt200320>
    RptBalanceSheet = "RBLST",         //<pt200320>
    RptTrialBalance = "RTRBL",         //<pt200320>        
    RptCustStatement = "RCSTM",        //<pt200320>
    RptAgentStatement = "RASTM",       //<pt200320>

    //sjcho 20200909 - Add Financial Report (Consolidated)
    RptIncomeStatementM = "RICSTM",
    RptBalanceSheetM = "RBLSTM",
    RptTrialBalanceM = "RTRBLM",
    //sjcho end

    RptBatchStatement = "RBSTMT",

    //<pt200320:
    ////2019.07.10 김학윤 추가
    //public const string BatchRecogDeatil: "BRCD",
    //public const string TrialBalanceDetail: "TRBD",
    //public const string BalanceSheetDetail: "BASD",
    //public const string IncomeStatementDetail: "ICSD",
    //public const string PeriodClosingDetail: "PECD",
    //public const string YearEndProcessingDeatil: "YEPD",
    PeriodClosing = "PECD",     //<pt200320: Change field name>
    //public const string YearEndProcessing: "YEPD", //<pt200320: Use EndYearProc>
    //pt200320>

    ReportQuery = "REPQ",    //10062= Report Query List
    BankTransfer = "BKTF",    //10065= Bank Transfer List
    BankRecActivity = "BKRCA",    //10066= Bank Rec. Activity List
    CustPaymentMemo = "CPAYM",    //10083= Customer Pay Memo

    //19.07.09 hykim 추가
    PayrollSummary = "PRSM",
    // <chuck date="2024-07-02" desc="Use New Payroll" />
    Payroll2 = "PAYROLL2",

    //public const string AgentPayment: "AGPM", //sjcho 20210128 - remove (not used jobname)

    //public const string AcctAdjustment: "ACADJ",   //<200320: Not action binding menu>
    PrepaidExpenseAdjustment = "PEAM",
    DepreciationAdjustment = "DPAM",
    AmortizationAdjustment = "AMAM",
    IncomeTaxAdjustment = "ICTAX",      //<pt200320>

    InvoAdj = "IVAJ",      // 10040
    CrDbAdj = "CDAJ",
    APayAdj = "APAJ",

    SalesTaxReturn = "STRT",
    //public const string SalesTaxReturnList: "STRTL",   //<pt200320: Use SalesTaxReturn>

    // Expense Claim
    EmClaim = "ECLM",
    EmClaimList = "ECLML",

    EmReceipt = "ERCT",
    XpenseAll = "XPALL",

    /// <summary>
    /// Probably GBill
    /// </summary>
    Expense = "EXPNS",      //170306 General Expense Entry

    BadDebtExpense = "BDEBT",   //<pt200320>
    PaymentHistory = "PAYMTH",
    //#endregion
    PaymentPrep = "PAYMTP",

    //[MapValue("GENL")]General,      //60
    Warehouse = "WHSE",
    WHRcpt = "WHRC",        // FMS Other - Warehouse Receipt
    WHRcptPanP = "WHRP",
    WHRcv = "WHRCV",        //170303: FMS Warehouse - Receiving
    WHShip = "WHSHP",
    //<pt200320: Replace
    //public const string WHInven: "WHIV",
    WHInvenSummary = "WHIVS",
    WHInvenDetail = "WHIVD",
    //pt200320>
    WHStorageInv = "WHSTI", //170303: Wahrehouse Storage Invoice
    WHInvoice = "WHINVO",    // jejeon 220726 - Add
    WHBill = "WHBILL",       // jejeon 220726 - Add
    WHCrDb = "WHCRDB",       // jejeon 220726 - Add
    WHCustomer = "WHCUS",    // jejeon 220726 - Change field name (Company)
    WHItem = "WHIT",
    WHLoc = "WHLOC",        //170303

    MemoList = "MEML",
    RecentBL = "RCBL",
    AutoCharge = "AUTC",
    CfsCharge = "CFSC",

    // For Settings > Ocean Buying
    //BuyRate = "BUYR",       
    OceanRate = "OCER",

    AirRate = "AIRR",       // For Settings > Air Buying

    // For Settings > Selling Rate
    //RateTable = "RATE",     
    SellingRate = "SELR",

    CreditCardSetup = "CCARD",      //<pt200322: FMS>

    OEBook = "OEBK",       // 70
    OELoad = "OELD",
    OILoad = "OILD",
    Security = "SECU",     // 77
    OIContainer = "OICN",
    OIVessel = "OIVS",

    OIMPims = "OIMP",      // 80
    OIHPims = "OIHP",
    OiPims = "OIPIM",   //170303 : OI Shipment
    OiSoPims = "OISOP", //170303: OI Shipment/Shipping Order

    OEMPims = "OEMP",
    OEHPims = "OEHP",
    OePims = "OEPIM",   //170303: OE Shipment
    OeSoPims = "OESOP", //170303: OE Shipment/Shipping Order

    AIMPims = "AIMP",
    AIHPims = "AIHP",
    AiPims = "AIPIM",   // 170303: AI Shipment
    AiSoPims = "AISOP", // 170303: AI Shipment/Shipping Order

    AEMPims = "AEMP",
    AEHPims = "AEHP",
    AePims = "AEPIM",   // 170303: AE Shipment
    AeSoPims = "AESOP", //170303: AE Shipment/Shipping Order

    // PimsUser = "PUSR",
    // PimsCustomer = "PCUS",
 
    WebNews = "WNEW",      // 90
    WebKCS = "WKCS",
    WebCargo = "WCAR",
    WebMap = "WMAP",
    WebDeniedParty = "WDNP",
    WebAESDirect = "WAES",
    WebLoginTrack = "WLTR",
    WebPims = "WPIM",
    WebPierPass = "WPPS",
    WebFaxCore = "WFXC",
    WebFaxCoreB = "WFCB",

    //[MapValue("OIQT")]OIQuotation, // 100
    //[MapValue("OOQT")]OOQuotation,
    SeaQuotation = "SQUOT",     // Security Control
    //<pt210609: Use SeaQuotation
    //public const string OiQuot: "OIQT",    //170303
    //public const string OeQuot: "OEQT",    //170303
    //pt210609>
    OtherOP = "OTOP",
    AirQuotation = "AQUOT",
    //[MapValue("AIQT")]AIQuotation,
    //[MapValue("AOQT")]AOQuotation,
    //<pt210609: Use AirQuotation
    //public const string AiQuot: "AIQT",    //170303
    //public const string AeQuot: "AEQT",    //170303
    //pt210609>

    //170303: Use OtherOP
    //public const string ForwardingOtherOP: "OTOP",      // "FOT"

    //#region CHB
    Entry = "ETRY",        // 100
    EntryBl = "ETRB",       //<pt210714>
    ElectronicInvoice = "EINV",
    DailyStatement = "DSTM",
    PMS = "PMST",
    Inbond = "IBND",
    Drawback = "DRBK",
    Drawback7553 = "7553",
    Recon = "RCON",
    OGAFDA = "OFDA",
    OGAUSDT = "OUDT",
    OGAFCC = "OFCC",
    OGAUSDA = "OUDA",
    F7533 = "7533",
    //pt150508begin
    CargoRls = "ERLS",
    FdaProduct = "FDAP",
    PeriodicDailyStmt = "PDST",
    //pt150508end
    BatchDailyStmt = "BDST",
    //pt210319
    ChbOtherOp = "COTOP",
    //#endregion

    InventoryItem = "INVI",        // 10001
    InventoryLocation = "INVL",
    InventoryReceive = "INVR",
    InventoryCustomer = "INVC",
    InventoryShip = "INVS",
    InventoryShipItem = "INVSI",
    InventoryHistory = "INVH",
    Inventory = "INVT",

    AMSVoyage = "AMSV",        // 10011
    AMSMaster = "AMSM",
    AMSHouse = "AMSH",
    AMSUser = "AMSU",
    AMSBranch = "AMBR",
    AMSGroup = "AMGR",
    AMSBilling = "AMBI",
    AMSHistory = "AMHI",
    AMSC1History = "AMC1",

    ACIVoyage = "ACIV",        // 10021
    ACIMaster = "ACIM",
    ACIUser = "ACIU",
    ACIUsageRpt = "ACIR",
    ACIManifest = "ACIEM",
    
    //sjcho 20210128 - use GInvo
    //public const string OtherInvoice: "OINV",     // 10031
    //sjcho end
    //<pt210608: Use WHStorageInv>
    //public const string StorageInvoice: "SINV",

    ISF = "ISFL",          // 10051
    ISFImporter = "ISFI",
    ISFUser = "ISFU",
    ISFBranch = "ISFB",
    ISFGroup = "ISFG",

    Query = "QURY",

    Protest = "PROT",


    // ABI related
    ABIWorkIn = "ABWI",     // My ABI Transaction 메뉴로 사용함. (kskim)
    ABIAllList = "ABAL",    // All ABI Transaction 메뉴로 사용함. (kskim)
    ABIWPHistory = "ABWP",

    FIRMSCode = "FIRM",
    ScheduleD = "SCHD",
    ScheduleK = "SCHK",

    UNLocation = "UNLO",
    ARCollection = "ARCO",

    EDI315Code = "315C",
    EDI310Code = "310C",
    SendBl2PartnerOcean = "SB2PO",
    SendBl2PartnerAir = "SB2PA",

    ExchangeRate = "EXCH",

    CommInvoice = "CINV",

    //[MapValue("EXTR")]Extra: 40000,
    //[MapValue("SPCL")]Special: 50000,

    PUInvoice = "PINV",

    AccountGeneral = "AGEN",

    // Fulfillment
    Fulfillment = "FFM",    //170303 Security Control from FMS
    FfmOrderFulfilling = "FOE",                                 //Fulfillment Shipping.
    FfmReceiving = "FRCV",                                      //Fulfillment Receiving Invoicing.                       
    FfmStorage = "FSTG",                                        //Fulfillment Storage Invoicing.
    FfmAll = "FFMALL",                                          //Fulfillment RCV, FOE, FSTG.
    FfmCarrierLabel = "FFMCRLBL",                               //Fulfillment Carrier(UPS/USPS/FedEX) Lable files.
    // CRM
    Crm = "CRM",    //170303
    CrmCommunication = "CRMCM",
    // CHB
    //public const string ChbEntry: "ETRY",  

    LogisTask = "TASK",

    // DIS
    DisDocFile = "DISDOC",                                      //++2016.05.24 by 유석(s.yoo) DIS 전송 Document File Preview 기능 지원.

    // iFMS Cloud
    OIHMyPims = "OIHMP",                                        //++ 2017.02.02 by 신다원
    OEHMyPims = "OEHMP",                                        //++ 2017.02.03 by 신다원

    OIMMyPims = "OIMMP",                                        //추가 by 양재환 2017.02.06
    OEMMyPims = "OEMMP",                                        //추가 by 양재환 2017.02.06

    OIPoPims = "OIPO",                                          //추가 by 양재환 2017.02.02

    AIMMyPims = "AIMMP",                                        //추가 by 양재환 2017.02.13
    AEMMyPims = "AEMMP",                                        //추가 by 양재환 2017.02.13

    AIHMyPims = "AIHMP",                                        //추가 by 양재환 2017.02.13
    AEHMyPims = "AEHMP",                                        //추가 by 양재환 2017.02.13

    // PimsOceanBooking = "POBOOK",                                //추가 by 신다원 2017.02.16
    // PimsOceanVanning = "POVANN",                                //추가 by 신다원 2017.02.16

    // PimsAirBooking = "PABOOK",                                  //추가 by 양재환 2017.03.03
    // PimsAirVanning = "PAVANN",                                  //추가 by 양재환 2017.03.03

    // PimsOrder = "PORDR",        //<pt200320 - iFMS>
    // PimsPartnerLogin = "PPLGN", //<pt200320 - iFMS>

    //170303begin
    CfsEdi = "CFSED",   // Security Control
    CfsEdiTo = "CFSEO",
    CfsEdiFrom = "CFSEI",

    OiAgentEdi = "OIAGE",   // OI - B/L From Partner
    AiAgentEdi = "AIAGE",   // OI - B/L From Partner

    ChgBillCode = "CNGBL",  // Utility - Change Billing Code
    CmpAddrPrint = "CMPPR", // Utillity - Company Address Label Printing

    //pt170306begin: SecurityCode already defined in Constants.SecurityCodeType
    //public const string SystemSetup: "SYSET",
    //public const string AdvancedSetup: "ADSET",
    //pt170306end
    //170303end

    // 2017.05.15 정우영 추가
    AIMRefNo = "AIMRefNo",
    AIMMawbNo = "AIMMawbNo",
    // 2017.05.15 정우영 추가 끝

    // 2017.05.19 정우영 추가
    OEMRefNo = "OEMRefNo",
    OEMMblNo = "OEMMblNo",
    // 2017.05.19 정우영 추가 끝

    OIMRefNo = "OIMRefNo",
    OIMMasterBlNo = "OIMMasterBlNo",

    AEMRefNo = "AEMRefNo",
    AEMMawbNo = "AEMMawbNo",

    //2017 07.12 정우영 추가
    OEContainer = "OECN",
    OEHPoNo = "OEPO",
    //2017.07.12 김형진 추가 
    AIContainer = "AICN",
    AIHPoNo = "AIPO",

    //2017.07.27 이태현 추가
    OITruckLoad = "OITL",


    OECBook = "OECBK",      //<pt200320>
    OEJapanEdi = "OENAC",   //<pt200320>
    AEEAirWayBill = "AEEAW",   //<pt200320>

    SwitchToAci = "TOACI",      //<pt200320>

    BatchRecog = "BRECG",       //<pt200322>

    SystemSetup = "SSETU",      //<pt200322>
    AdvancedSetup = "ADSETU",   //<mkpark200413>
    ClientSetup = "CLSETU",     //<mkpark200413>
    SuntekSetup = "STSETU",     //<mkpark200413>
    SubscriberManager = "SUBSM", //<mkpark200413>
    ToolMemo = "TMEMO",         //<pt200322: Tool - Memo>
    ToolBlock = "TBLCK",        //<pt200322: Too - Block>
    ToolCancelBlock = "TCBLK",  //<pt200322: Tool - Cancel Block>
    ToolOpClose = "TOPCL",      //<pt200322: Tool - OP Close>
    ToolCancelOpClose = "TCOPC", //<pt200322: Tool - Cancel OP Close>
    ToolRecog = "TRECG",        //<pt200322: Tool - Recognize>
    ToolCancelRecog = "TCREC",  //<pt200322: Tool - Undo Recognize>

    // Home
    RptAgentBalance = "RAGTB",
    RptCustBalance = "RCSTB",
    //RptVendBalance: "RVENB",
//
    //#region Reports <pt200320>

    RptOiShipment = "ROISH",
    RptOiInlandTransport = "ROIIT",
    RptOiANLog = "ROIAL",
    RptOiPendingCargo = "ROIPC",
    RptOiRlsHistory = "ROIRH",

    RptOeShipment = "ROESH",
    RptOeBrokerage = "ROEBR",

    RptAiPreAlert = "RAIPA",
    RptAiEstProfit = "RAIEP",

    RptAeEstProfit = "RAEEP",

    RptAmsUsage = "RAMUS",
    RptAmsContainerTrack = "RAMCT",
    RptAmsLifting = "RAMLF",
    RptTotalAmsLifting = "RAMTL",

    RptWhChargeItemSummary = "RWHCS",
    RptWhActivitySummary = "RWHAS",
    RptWhActivityDetail = "RWHAD",

    RptDeferred = "RDEFD",

    USDA = "USDA",

    // Accounting
    RptJournalVoucher = "RVOCH",
    AcctInfo = "ACTIF",     // Add 2020-07-10 jhchoi : Ocean Import > P Column > "Invoice Bill Cr/Db Note"

    // OP Report
    RptEstProfit = "RESTP",
    RptGrossProfit = "RGRSP",
    RptVendorCost = "RVECO",
    RptExpense = "REXCO",
    RptVolume = "RVOLM",
    RptProfitBySalesman = "RPBSM",
    RptCustomerActivity = "RCACT",
    RptDutyPendings = "RDPND",
    RptIssueReady = "RIRDY",
    RptSpecial = "RSPEC",
    RptOpPerfom = "ROPPE",
    RptBranchPerform = "RBRPE",

    //#endregion

    // Hybrid
    HybridInvoice = "HYINVO",
    HybridBill = "HYBILL",
//
    //#region NavMenu <mkpark200417>

    RptJournalBook = "RPJB",
    RptISFUsage = "RPISFU",
    RptMasterInvoice = "RPMINVO",
    RptMasterArrivalNotice = "RPMAN",
    RptTSASecurity = "RPTSAS",
    RptTSAUnknown = "RPTSAU",
    RptTransfer = "RPTRA",
    RptArrivalNotice = "RPAN",
    RptEmptyCntrRtn = "EMPTYCR",
    RptMAuthEntry = "RPMAE",
    RptUSDA = "RPUSDA",
    RptReleaseOrder = "RPRO",
    RptLienNotice = "RPLIEN",
    RptPOD = "RPPOD",
    RptPickup = "RPPIC",
    RptStraightBL = "RPSTBL",
    RptPickupGermany = "RPPICG",
    RptPickupItaly = "RPPICI",
    RptPrePickup = "RPPPIC",
    RptDO = "RPDO",
    RptIT = "RPIT",
    RptOIHouseBl = "RPOIH",
    RptAWB = "RPAWB",
    RptOOHouseBL = "RPOOH",
    RptAO_CargoManifest = "RPAOCM",
    RptOO_CargoManifest = "RPOOCM",
    RptCorrection = "RPCORR",
    RptAES = "RPAES",
    RptExDec = "RPEXD",
    RptBankDraft = "RPBD",
    RptOriginCertificate = "RPOC",
    RptShippingAdvice = "RPSA",
    RptShippingInstruction = "RPSI",
    RptDocumentPackage = "RPDOPA",
    RptAging = "RPAGI",
    RptAgentPackage = "RPAGPA",
    RptLabel = "RPLAB",
    RptLabelAir = "RPLABA",
    RptLabelPouch = "RPLABP",
    RptLabelBook = "RPLABB",
    RptLabelFolder = "RPLABELF",    
    RptMasterUSDA = "RPMUSDA",
    RptDeliveryOrderShort = "RPDOS",
    RptPendingList = "RPPL",
    RptC_ExDec = "RPCEXD",
    RptWhseLabelOher = "WRLABEL",
    RptMBatchHouseBL = "RPMBHBL",
    RptMBatchAWB = "RPMBAWB",
    RptHBatchAWB = "RPHBAWB",
    RptPIMS_EDI_OI = "RPPEOI",
    RptPIMS_EDI_OE = "RPPEOE",
    RptPIMS_EDI_AI = "RPPEAI",
    RptPIMS_EDI_AE = "RPPEAE",
    RptACIImport = "RPACI",
    RptAms2OI = "RPAMSOI",
    UpdateCheckApproved = "UCAPP",
    AutoBillingInvoice = "ABINV",
    PostInvACCT2000 = "PINA",
    PostDepoACCT2000 = "PDEA",
    PostClearDepoACCT2000 = "PCDA",
    PostCheckACCT2000 = "PCHA",
    PostClearCheckACCT2000 = "PCCA",
    AutoBillingStorage = "ABSTR",
    ARPEDI = "ARPE",
    RptIPI = "RPIPI",
    RptANandROrder = "RPANRO",
    RptCargoAvailableNotice = "RPCANO",
    RptCancelIT = "RPCIT",
    RptUploadPOList = "RPUPO",
    RptPOItemList = "RPPOIL",
    RptPOendingBalance = "RPPOB",
    RptPOList = "RPPOL",
    RptInvoiceS = "RPINVOS",
    RptCrDbBatch = "RPCRB",
    RptPreliminaryClaim = "RPPREC",
    UpdateCRDBshare = "UCRS",
    EDIascX12_214 = "EDIAS",
    EDIuscom = "EDIUS",
    RptDGdoc = "RPDGD",
    RptBankReconHistory = "RPBRH",
    RptDailyBankBalance = "RPDBB",
    
    //#endregion

    RptDevann = "RPDEV",
    RptLoadPlan = "RPLDP",
    RptCommercialInvoice = "RPCOINV",
    RptPackingList = "RPPACKL",

    //<pt200803: Add>
    CompanyContact = "COMCT",
    CompanyGroup = "COMGR",

    //<pt201128: Add for iFMS>
    SecurityGroup = "SECGR",
    SecurityControl = "SECCT",

    //<hykim 21.06.01 Accounting Adjust Journal Entry Detail 추가>
    //AdjustJournalEntry: "ADJE",

    FlexiTank = "FLXTNK",

    // ----------------------------------------------
    // Additionally added properties in cloud version
    // ----------------------------------------------
    //<pt220128: We donot need these.
    // InvoiceOi = "OIINVO",
    // InvoiceOe = "OEINVO",
    // CrDbOi = "OICRDB",
    // BillOi = "OIBILL",
    //pt2220128>

    Department = "DEPT",        // 2022-08-22 jhchoi : Add iFMS Cloud

    OpInvoice = "OPINVOICE",            // OP > Invoice 
    OpBill = "OPBILL",                  // OP > Bill
    OpCrDb = "OPCRDB",                  // OP > CrDb

    OtQuotation = "OTQUOT",      //2023-12-12 eytak: Add iFMS Cloud > Other Shipment - Quotation

    BTOrder = "BTODR",         //2024-09-13 jejeon: Add iFMS Cloud > Orchid Trans - Order
    BTLoadPlan = "BTLP",        //2024-09-13 jejeon: Add iFMS Cloud > Orchid Trans - Load
    BTDo = "BTDO",         //2024-09-13 jejeon: Add iFMS Cloud > Orchid Trans - Local DO
    MyEvent = "MYEVT",           // 2024-10-16 jhchoi : Add My Event
    BusienssIntell = "BINTEL",
    OtherContainer = "OTOPC",
    OrchidBaro = "OCBO",
}

export function getOpConstant(jobName: string, opType: string) {
    let opName: string = jobName.substring(0, 2);
    if(['OI', 'OE', 'AI', 'AE', 'OT', 'WH', 'AC', 'BT'].indexOf(opName) < 0)
        opName = opType.toUpperCase();
    switch(opName) {
        case "OI": return constants.operations.oceanImport;
        case "OE": return constants.operations.oceanExport;
        case "AI": return constants.operations.airImport;
        case "AE": return constants.operations.airExport;
        case "OT": return constants.operations.otherShipment;
        case "WH": return constants.operations.warehousing;
        case "AC": return constants.operations.accounting;
        case "BT": break;
        default:
            return '';
    }

    let opName2: string = jobName.substring(0, 3);
    if(['BTO', 'BTL', 'BTD'].indexOf(opName) < 0)
        opName2 = opName2.toUpperCase();
    switch(opName2) {
        case "BTO": return constants.operations.order;
        case "BTL": return constants.operations.load;
        case "BTD": return constants.operations.localDO;
        default:
            return '';
    }
}

export function getOpTypeConstant(jobName:string, opType?:string) {
    let opName: string = jobName.substring(0, 2);
    if(['OI', 'OE', 'AI', 'AE', 'OT', 'WH', 'AC', 'BT'].indexOf(opName) < 0)
        opName = opType?.toUpperCase() ?? '';
    switch(opName) {
        case "OI": return constants.opTypes.oceanImport;
        case "OE": return constants.opTypes.oceanExport;
        case "AI": return constants.opTypes.airImport;
        case "AE": return constants.opTypes.airExport;
        case "OT": return constants.opTypes.otherShipment;
        case "WH": return constants.opTypes.warehousing;
        case "AC": return constants.opTypes.accounting;
        case "BT": break;
        default:
            return '';
    }

    let opName2: string = jobName.substring(0, 3);
    if(['BTO', 'BTL', 'BTD'].indexOf(opName) < 0)
        opName2 = opName2?.toUpperCase() ?? '';
    switch(opName2) {
        case "BTO": return constants.opTypes.order;
        case "BTL": return constants.opTypes.load;
        case "BTD": return constants.opTypes.localDO;
        default:
            return '';
    }
}

export function getJobNameFromInvBillCrDbJobType(fType:string): JobNames {
    switch(fType) {
        case "OIH": return JobNames.OIHbl;
        case "OIM": return JobNames.OIMbl;
        case "OEH": return JobNames.OEHbl;
        case "OEM": return JobNames.OEMbl;
        case "AIH": return JobNames.AIHbl;
        case "AIM": return JobNames.AIMbl;
        case "AEH": return JobNames.AEHbl;
        case "AEM": return JobNames.AEMbl;
        case "GEN":
        case "OTH": 
            return JobNames.OtherOP;
        case "WHR": return JobNames.WHRcv;
        case "WRE": return JobNames.WHRcv;
        case "WSH": return JobNames.WHShip;
        case "WHS": return JobNames.WHShip; // Typo??
        case "STO": return JobNames.WHRcpt;
        case "ODM": return JobNames.BTOrder;
        case "ODL": return JobNames.BTLoadPlan;
        case "BTD": return JobNames.BTDo;
        default: return JobNames.None;
    }
}

export function isMasterJob(jobName: JobNames|string, includeOP: boolean = false ) {
    let ret = false;
    switch(jobName) {
        case JobNames.OIMbl:
        case JobNames.OEMbl:
        case JobNames.AIMbl:
        case JobNames.AEMbl:
            ret = true;
            break;
        case JobNames.OtherOP:
            ret = includeOP;
            break;
    }
    return ret;
}

//<pt220304>
export function isHouseJob(jobName: JobNames|string): boolean {
    return [JobNames.OIHbl, JobNames.OEHbl, JobNames.AIHbl, JobNames.AEHbl].indexOf(jobName as JobNames) >= 0;
}

export function getOpByjobName(jobName: string) {
    switch (jobName) {
        case JobNames.OIMbl: case JobNames.OIHbl: return constants.opTypes.oceanImport;
        case JobNames.OEMbl: case JobNames.OEHbl: return constants.opTypes.oceanExport;
        case JobNames.AIHbl: case JobNames.AIMbl: return constants.opTypes.airImport;
        case JobNames.AEHbl: case JobNames.AEMbl: return constants.opTypes.airExport;
        case JobNames.OtherOP: return constants.opTypes.otherShipment;
        case JobNames.WHRcv: case JobNames.WHShip: return constants.opTypes.warehousing;
        case JobNames.Company: return constants.opTypes.customer;
        case JobNames.BTOrder: return constants.opTypes.order;
        case JobNames.BTLoadPlan: return constants.opTypes.load;
        case JobNames.BTDo: return constants.opTypes.localDO;
        default:
            return '';
    }
}

export function getOpByName(jobName: string) {
    switch(jobName) {
        case constants.opTypes.oceanImport: return "OI";
        case constants.opTypes.oceanExport: return "OE";
        case constants.opTypes.airImport: return "AI";
        case constants.opTypes.airExport: return "AE";
        case constants.opTypes.otherShipment: return "OT";
        case constants.opTypes.warehousing: return "WH";
        case constants.opTypes.accounting: return "AC";
        // case constants.opTypes.order: 
        // case constants.opTypes.load: 
        // case constants.opTypes.localDO: 
        //     return "BT";
        case constants.opTypes.myEvent: return "OI";
        default:
            return '';
    }
}

export function getJobNameByTbName(tbName:string): JobNames {
    switch(tbName.toLowerCase()) {
        case 't_oimmain':   return JobNames.OIMbl;
        case 't_oihmain':   return JobNames.OIHbl;
        case 't_oommain':   return JobNames.OEMbl;
        case 't_oohmain':   return JobNames.OEHbl;
        case 't_aimmain':   return JobNames.AIMbl;
        case 't_aihmain':   return JobNames.AIHbl;
        case 't_aommain':   return JobNames.AEMbl;
        case 't_aohmain':   return JobNames.AEHbl;
        case 't_genmain':   return JobNames.OtherOP;
        case 't_wreceive':  
        case 't_wreceivehd':  
            return JobNames.WHRcv;
        case 't_wshiphd':   return JobNames.WHShip;
        case 't_whperiod':  return JobNames.Warehouse;
        case 't_storage':   return JobNames.Inventory;
        case 't_company':  return JobNames.Company;
        case 'v_arcollect': return JobNames.CustPaymentMemo; 
        case 't_oohquotation': return JobNames.SeaQuotation;
        case 't_btorder':   return JobNames.BTOrder;
        case 't_btload':    return JobNames.BTLoadPlan;
        case 't_btdo':      return JobNames.BTDo;
        default:
            // Not source of invoice, bill, crdb
            return JobNames.None;
    }
}
export function getTbNameByJobName(jobName: string) {
    switch(jobName) {
        case JobNames.OIMbl:                    return 'T_OIMMAIN';
        case JobNames.OEMbl:                    return 'T_OOMMAIN';
        case JobNames.OIHbl:                    return 'T_OIHMAIN';

        case JobNames.OEBook:   
        case JobNames.OEHbl:                    return 'T_OOHMAIN';

        case JobNames.AIMbl:                    return 'T_AIMMAIN';
        case JobNames.AEMbl:                    return 'T_AOMMAIN';
        case JobNames.AIHbl:                    return 'T_AIHMAIN';
        case JobNames.AEHbl:                    return 'T_AOHMAIN';
        case JobNames.OtherOP:                  return 'T_GENMAIN';
        case JobNames.WHRcv:                    return 'T_WRECEIVEHD';
        case JobNames.WHShip:                   return 'T_WSHIPHD';
        case JobNames.Company:                  return 'T_COMPANY';
        case JobNames.AMSHouse:                 return 'T_AMSHOUSE';
        case JobNames.AMSMaster:                return 'T_AMSMASTER';
        case JobNames.ACIManifest:              return 'ACIHOUSE';
        case JobNames.ISF:                      return 'T_ISFHEADER';
        case JobNames.CommInvoice:              return 'T_COMM';
        case JobNames.FfmOrderFulfilling:       return 'FFMREQUEST';
        case JobNames.FfmReceiving:             return 'FFMRECEIVING';
        case JobNames.OITruckLoad:              return 'T_TLOADHD';

        case JobNames.InventoryItem:            
        case JobNames.WHRcpt:                   
        case JobNames.WHRcptPanP:               return 'T_INVENHD';

        case JobNames.SellingRate:                
        case JobNames.OceanRate:                  return 'T_AOTHERINFO';

        case JobNames.Invoice:                  
        case JobNames.InvoAdj:                  
        case JobNames.GInvo:                    
        case JobNames.WHStorageInv:             
        case JobNames.AutoBillingStorage:       
        case JobNames.AutoBillingInvoice:       return 'T_INVOHD';

        case JobNames.CrDb:                     
        case JobNames.CrDbAdj:                  return 'T_CRDBHD';

        case JobNames.Bill:                     
        case JobNames.APayAdj:                  
        case JobNames.GBill:                    return 'T_APHD';

        case JobNames.BillPayment:              
        case JobNames.CustPayment:              
        case JobNames.AgntPayment:             
        case JobNames.CheckDeposit:             
        case JobNames.UndoDeposit:              
        case JobNames.CCPayment:                
        case JobNames.Settle:                   return 'T_DEPOHD';

        case JobNames.BankTransfer:             return 'T_BANKTRANSFER';
        case JobNames.BankRecActivity:          
        case JobNames.BankRecon:                return 'T_BANKRECON';
        case JobNames.OIContainer:              return 'T_OIMCONTAINER';
        case JobNames.OEContainer:              return 'T_OOMCONTAINER';
        case JobNames.AMSVoyage:                return 'T_AMSVOYAGE';

        case JobNames.AMSHistory:               
        case JobNames.AMSC1History:             return 'T_AMSHISTORY';

        case JobNames.SeaQuotation:             return 'T_OOHQUOTATION';
        case JobNames.AirQuotation:             return 'T_AOHQUOTATION';
        case JobNames.OtQuotation:              return 'T_GENQUOTATION';
        case JobNames.SlipJournal:              return 'T_SLIPHD';
        case JobNames.CustPaymentMemo:          return 'V_ARCOLLECT';

        case JobNames.OIMPims:                  
        case JobNames.OEMPims:                  
        case JobNames.AIMPims:                  
        case JobNames.AEMPims:                  return 'BOOKING';

        case JobNames.OIHPims:                  
        case JobNames.OEHPims:                  
        case JobNames.AIHPims:                  
        case JobNames.AEHPims:                  return 'VANNING';

        case JobNames.OIMMyPims:                
        case JobNames.OEMMyPims:                
        case JobNames.AIMMyPims:                
        case JobNames.AEMMyPims:                return 'BOOKING';

        case JobNames.OIHMyPims:                
        case JobNames.OEHMyPims:                
        case JobNames.AIHMyPims:                
        case JobNames.AEHMyPims:                return 'VANNING';

        case JobNames.OiSoPims:                 
        case JobNames.OeSoPims:                 
        case JobNames.AiSoPims:                 
        case JobNames.AeSoPims:                 return 'PO';

        // case JobNames.PimsCustomer:             return 'CUSTOMER';
        // case JobNames.PimsUser:                 return 'USER';
        case JobNames.Bank:                     return 'T_CODEBANK';
        case JobNames.BillingCode:              return 'T_NCODECHARGE';
        case JobNames.GLNo:                     return 'T_CODEGLNO';
        case JobNames.CreditCardSetup:          return 'T_CREDITCARD';
        case JobNames.SalesTaxReturn:           return 'T_TAXRETURNHD';
        case JobNames.PayrollSummary:           return 'T_PAYROLL';
        case JobNames.Payroll2:                 return 'T_PAYROLL2';
        case JobNames.BatchMemo:                return 'T_BATCHMAINHD';

        case JobNames.PrepaidExpenseAdjustment: 
        case JobNames.DepreciationAdjustment:   
        case JobNames.AmortizationAdjustment:   
        case JobNames.BadDebtExpense:           return 'T_ADSLIPHD';

        case JobNames.Scac:                     return 'T_CODESCAC';

        case JobNames.BTOrder:                  return 'T_BTORDER';
        case JobNames.BTLoadPlan:               return 'T_BTLOAD';
        case JobNames.BTDo:                     return 'T_BTDO';
        
        default: return '';
    }
}

export function getMasterJob(subJob:string, dbType:string = 'FMS3') {
    let masterJob = subJob;
    if(dbType === 'FMS3') {
        switch(subJob) {
            case JobNames.OIHbl:    masterJob = JobNames.OIMbl; break;
            case JobNames.OEHbl:    masterJob = JobNames.OEMbl; break;
            case JobNames.AIHbl:    masterJob = JobNames.AIMbl; break;
            case JobNames.AEHbl:    masterJob = JobNames.AEMbl; break;
        }
    }
    return masterJob;
}

/**
 * pt220912
 * @param job 
 * @returns 
 */
export function isAirJob(job: JobNames|string) {
    return [JobNames.AIMbl, JobNames.AIHbl, JobNames.AEMbl, JobNames.AEHbl].indexOf(job as JobNames) >= 0;
}

export function isExportJob(job: JobNames|string) {
    return [JobNames.OEMbl, JobNames.OEHbl, JobNames.AEMbl, JobNames.AEHbl].indexOf(job as JobNames) >= 0;
}

export function getJobNameFromInvBillCrdbTbName(tbName: string,  acctTbName: string){
    switch(tbName){
        case "T_INVOHD":
            if(acctTbName === "T_STORAGE") 
              return JobNames.WHStorageInv;
            else if (acctTbName === "")
                return  JobNames.GInvo;
            else 
                 return JobNames.Invoice;
        case "T_APHD": 
            if(acctTbName)
                return JobNames.Bill;
            else 
            return JobNames.GBill;
        case "T_CRDBHD": return JobNames.CrDb; 
        default: return JobNames.None;
    }           
}

export function getOpTypeFromInvBillCrdbTbName(tbName: string){
    switch(tbName){
        case "T_WHPERIOD":
        case "T_WRECEIVE":
        case "T_WSHIPHD":
        case "T_WRECEIVEHD":
            return constants.opTypes.warehousing;
        default: 
            return constants.opTypes.accounting;
    }
}
